// ----------------------------------------------------------------------

const account = {
  displayName: 'cKers',
  email: 'admin@ckersfinance.in',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
